import { Add, Delete, Edit, Flag } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Avatar, Checkbox, Chip, FormControl, InputLabel, MenuItem, Paper, Select, SwipeableDrawer, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { SortableContainer } from 'react-sortable-hoc';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import { useJumboApp } from '@jumbo/hooks';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
const validationSchema = yup.object({
  FL_MENU_NAME: yup.string().required('Menu Name is required'),
  FL_MODULE_CODE: yup.string().required('Module Code is required'),
  FL_SLUG: yup.string().required('Slug is required'),
  // FL_SHORTCUT: yup.string().required('Shortcut is required'),
  // FL_CREATED_AT: yup.date().required('Created At is required'),
  FL_SYGICONE: yup.string().required('Icon is required'),
});

const MenuDataTable = ({ menuitem }) => {
  const [menu, setMenu] = useState([])
  // const [roles, setRoles] = useState([]); 
  // const [branchesData, setBranchesData] = useState([]); 
  const [drawer, setDrawer] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isedit, setIsedit] = useState(false)
  const [svgPreview, setSvgPreview] = useState('');
const {rights} = useJumboAuth()
// console.log('rights',rights);
  const swal = useSwalWrapper();

  const formik = useFormik({
    initialValues: {
      FL_MENU_CODE: '',
      FL_MENU_NAME: '',
      FL_MODULE_CODE: '',
      FL_SLUG: '',
      FL_PARENT_MENU_CODE: '',
      FL_SHORTCUT: '',
      FL_CREATED_AT: '',
      FL_ORD: '',
      FL_SYGICONE: '',
    },
    validationSchema: validationSchema, // Your validation schema for menu fields
    onSubmit: async (values) => {
      // console.log(values);
      setLoading(true);
      if (isedit) {
        await jwtAuthAxios.post(`roleMenu/editmenu/${values.FL_MENU_CODE}`, values)
          .then((data) => {
            // console.log(data.data);
            if (data.data.status === "success") {
              fetchMenuData();
              setDrawer(false);
              swal.fire({
                icon: 'success',
                text: data.data.message,
              });
            } else {
              swal.fire({
                icon: 'error',
                text: 'Something Went Wrong',
              });
            }
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      } else {
        await jwtAuthAxios.post(`roleMenu/addmenu`, values)
          .then((data) => {
            if (data.data.status === "success") {
              fetchMenuData();
              setDrawer(false);
              swal.fire({
                icon: 'success',
                text: data.data.message,
              });
            } else {
              swal.fire({
                icon: 'error',
                text: 'Something Went Wrong',
              });
            }
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    },
  });

  useEffect(() => {
    setSvgPreview(formik.values.FL_SYGICONE);
  }, [formik.values.FL_SYGICONE]);

  function buildMenuTree(data, parentCode = 0) {
    const tree = [];

    data.forEach((item) => {
      if (item.FL_PARENT_MENU_CODE === parentCode) {
        const hasChildren = data.some((childItem) => childItem.FL_PARENT_MENU_CODE === item.FL_MENU_CODE);

        const node = {
          ...item,
          children: hasChildren ? buildMenuTree(data, item.FL_MENU_CODE) : undefined, // Recursive call for children

          // Add other properties as needed
        };

        tree.push(node);
      }
    });

    return tree;
  }
  const fetchMenuData = async () => {
    try {
      setMenu([])
      const { data } = await jwtAuthAxios.get('roleMenu/menu').then(async data => {
        if (data.data.status == 'sucess') {
          let buildMenu = buildMenuTree(data.data.data)
          setMenu(buildMenu);
        }
      });
      setMenu(data);
    } catch (error) {
      // Handle errors here
    }
  };
  // const userActiveInactiveHandler = async (value) => {
  //   try {
  //     const { data } = await jwtAuthAxios.post('userActive/'+value.id,value).then(data=>{

  //       if(data.data.status == "succes"){
  //         fetchMenuData()
  //         swal.fire({
  //           icon:'success',
  //           text:data.data.message,
  //         })
  //       } else{
  //       swal.fire({
  //         icon:'error',
  //         text:'something Went Wrong',
  //       })            
  //     }
  //   });
  //   } catch (error) {
  //     // Handle errors here
  //   }
  // };
  useEffect(async () => {
    fetchMenuData();
  }, [])
  useEffect(() => {
    if (drawer == false) {
      formik.resetForm()
      setIsedit(false)
    }
  }, [drawer])
  const editMenuItem = (menuItem) => {
    // Populate the form fields with the data of the menu item to edit
    formik.setValues({
      FL_MENU_CODE: menuItem.FL_MENU_CODE || '',
      FL_MENU_NAME: menuItem.FL_MENU_NAME || '',
      FL_MODULE_CODE: menuItem.FL_MODULE_CODE || '',
      FL_SLUG: menuItem.FL_SLUG || '',
      FL_PARENT_MENU_CODE: menuItem.FL_PARENT_MENU_CODE || '',
      FL_SHORTCUT: menuItem.FL_SHORTCUT || '',
      FL_CREATED_AT: menuItem.FL_CREATED_AT || '',
      FL_ORD: menuItem.FL_ORD || '',
      FL_SYGICONE: menuItem.FL_SYGICONE || '',
    });
    setIsedit(true)
    // Open the drawer if it's not already open
    setDrawer(true);
  };

  return (<div>
      {/* <LoadingButton variant="contained" onClick={() => setDrawer(true)} sx={{ display: 'flex', margin: '0 0px 22px auto' }} startIcon={<Add />} color="primary">
      Add Menu
    </LoadingButton> */}
     {rights?.insert ==1 &&  <LoadingButton variant="contained" onClick={() => setDrawer(true)} sx={{ display: 'flex', margin: '0 0px 22px auto' }} startIcon={<Add />} color="primary">
      Add Menu
    </LoadingButton>}
    {menu.length > 0 ?
      <TableContainer component={Paper}>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>Icon</TableCell>
              <TableCell>Menu name</TableCell>
              <TableCell>Module name</TableCell>
              <TableCell>Branches</TableCell>
              <TableCell>Parent Code</TableCell>
              <TableCell>Is active</TableCell>
              <TableCell align='right'>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <MenuTree menuData={menu} editMenuItem={editMenuItem} />
            {/* {menu.map((menu,index)=>{
             return(<TableRow key={index}>
              <TableCell>
             <div
            className="svg-container"
            style={{width: '25px'}}
            dangerouslySetInnerHTML={{ __html: menu.FL_SYGICONE }}
          />
              </TableCell>
              <TableCell>{menu.FL_MENU_NAME}</TableCell>
              <TableCell>{menu.FL_MODULE_CODE}</TableCell>
              <TableCell>{menu?.FL_SLUG}</TableCell>
              <TableCell>{menu.FL_ROLE_NAME}</TableCell>
              <TableCell>
              <Chip
              color={menu.FL_IS_ACTIVE == 1?"success":"error"}
                label={menu.FL_IS_ACTIVE == 1?"Active":"Inactive"}
            />
              </TableCell>
              <TableCell align='right'>
              <Chip
              color={"error"}
              icon={<Edit fontSize='18px'/>}
              label="edit"
            />
              </TableCell>
            </TableRow>)
          })} */}
          </TableBody>
        </Table>
      </TableContainer> : <TableSkeleton cols={7} />}
    <SwipeableDrawer
      anchor="right"
      open={drawer}
      onClose={() => setDrawer(false)}
      onOpen={() => setDrawer(true)}
    >
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: '400px',
          margin: '0 auto',
          p: 3,
        }}
        onSubmit={formik.handleSubmit}
      >
        <h3 style={{ padding: '5px', marginTop: '0' }}>Menu</h3>

        <TextField
          label="Menu name"
          variant="outlined"
          margin="normal"
          fullWidth
          {...formik.getFieldProps('FL_MENU_NAME')}
          error={formik.touched.FL_MENU_NAME && Boolean(formik.errors.FL_MENU_NAME)}
          helperText={formik.touched.FL_MENU_NAME && formik.errors.FL_MENU_NAME}
        />
        <TextField
          label="Module code"
          variant="outlined"
          margin="normal"
          fullWidth
          {...formik.getFieldProps('FL_MODULE_CODE')}
          error={formik.touched.FL_MODULE_CODE && Boolean(formik.errors.FL_MODULE_CODE)}
          helperText={formik.touched.FL_MODULE_CODE && formik.errors.FL_MODULE_CODE}
        />
        <TextField
          label="Slug"
          variant="outlined"
          margin="normal"
          fullWidth
          {...formik.getFieldProps('FL_SLUG')}
          error={formik.touched.FL_SLUG && Boolean(formik.errors.FL_SLUG)}
          helperText={formik.touched.FL_SLUG && formik.errors.FL_SLUG}
        />
        <TextField
          label="Parent Menu code"
          variant="outlined"
          margin="normal"
          fullWidth
          {...formik.getFieldProps('FL_PARENT_MENU_CODE')}
          error={formik.touched.FL_PARENT_MENU_CODE && Boolean(formik.errors.FL_PARENT_MENU_CODE)}
          helperText={formik.touched.FL_PARENT_MENU_CODE && formik.errors.FL_PARENT_MENU_CODE}
        />
        <TextField
          label="menu order"
          variant="outlined"
          type='number'
          margin="normal"
          fullWidth
          {...formik.getFieldProps('FL_ORD')}
          error={formik.touched.FL_ORD && Boolean(formik.errors.FL_ORD)}
          helperText={formik.touched.FL_ORD && formik.errors.FL_ORD}
        />
        <TextField
          label="SVG Code"
          variant="outlined"
          margin="normal"
          fullWidth
          multiline
          rows={6} // Adjust the number of rows as needed
          {...formik.getFieldProps('FL_SYGICONE')}
          error={formik.touched.FL_SYGICONE && Boolean(formik.errors.FL_SYGICONE)}
          helperText={formik.touched.FL_SYGICONE && formik.errors.FL_SYGICONE}
        />
        <div>
          <h3>SVG Preview</h3>
          <div style={{ maxWidth: '100px' }} dangerouslySetInnerHTML={{ __html: svgPreview }}></div>
        </div>
        <LoadingButton
          loading={loading}
          type="submit"
          variant="contained"
          onClick={formik.handleSubmit}
          color="primary"
          sx={{ marginTop: '16px' }}
        >
          Submit
        </LoadingButton>
      </Box>
    </SwipeableDrawer>

  </div>
  )
};

const MenuTree = ({ menuData, loop = 1, editMenuItem }) => {
  const {rights} = useJumboAuth()
// console.log('rights',rights);

  return (
    <>
      {menuData.map((menu) => (
        <React.Fragment key={menu.FL_MENU_CODE}>
          <TableRow >
            <TableCell sx={{ pl: loop * 2 }}>
              <div
                className="svg-container"
                style={{ width: '25px' }}
                dangerouslySetInnerHTML={{ __html: menu.FL_SYGICONE }}
              />
            </TableCell>
            <TableCell sx={{ pl: loop * 2 }}>({menu.FL_MENU_CODE}){menu.FL_MENU_NAME}</TableCell>
            <TableCell sx={{ pl: loop * 2 }}>{menu.FL_MODULE_CODE}</TableCell>
            <TableCell>{menu?.FL_SLUG}</TableCell>
            <TableCell>{menu.FL_PARENT_MENU_CODE}</TableCell>
            <TableCell>
              <Chip
                color={menu.FL_IS_ACTIVE == 1 ? "success" : "error"}
                label={menu.FL_IS_ACTIVE == 1 ? "Active" : "Inactive"}
              />
            </TableCell>
            <TableCell align='right'>
            {rights?.edit ==1 &&   <Chip
                color={"error"}
                icon={<Edit fontSize='18px' />}
                label="edit"
                onClick={() => editMenuItem(menu)}
              />}
              {/* <Chip
                color={"error"}
                icon={<Edit fontSize='18px' />}
                label="edit"
                onClick={() => editMenuItem(menu)}
              /> */}
            </TableCell>
          </TableRow>
          {/* <TableRow color="primary">
            <TableCell sx={{pl:loop *2}}>{menu.FL_MENU_NAME}</TableCell>
            <TableCell sx={{width:'30px'}}>
                  <Checkbox
                    checked={menu.FL_INSERT_ALLOWED == 1}
                  />
                </TableCell>
                <TableCell sx={{width:'30px'}}>
                  <Checkbox
                    checked={menu.FL_UPDATE_ALLOWED === 1}
                  />
                </TableCell>
                <TableCell sx={{width:'30px'}}>
                  <Checkbox
                    checked={menu.FL_DELETE_ALLOWED === 1}
                  />
                </TableCell>
                <TableCell sx={{width:'30px'}}>
                  <Checkbox
                    checked={menu.FL_VIEW_ALLOWED === 1}
                  />
                </TableCell>
                <TableCell sx={{width:'30px'}}>
                  <Checkbox
                    checked={menu.FL_PRINT_ALLOWED === 1}
                  />
                </TableCell>
                <TableCell sx={{width:'30px'}}>
                  <Checkbox
                    checked={menu.FL_EXPORT_ALLOWED === 1}
                  />
                </TableCell>
          </TableRow> */}
          {menu.children && menu.children.length > 0 && (
            <MenuTree menuData={menu.children} loop={(loop) + 1} editMenuItem={editMenuItem} />
          )}


        </React.Fragment>
      ))}
    </>
  );
};
MenuDataTable.Modulename='MENU';
export default MenuDataTable;
